import React from 'react';
import { useLocation } from 'react-router';
import '../../../CSS/hero_section.scss';

const HeroSectionContent = ({data})=> {
    // console.log(data);
    const {pathname} = useLocation();
return (
    <div className="hero-section-content">
            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-lg-3"></div>
                    <div className="col-md-6 col-lg-6">
                        {data && <h5 className="content-header">{data.title}</h5>}
                    </div>
                    <div className="col-md-3 col-lg-3"></div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3"></div>
                    <div className="col-md-6 col-lg-6">
                        {
                            data && (pathname === '/main/contact')?
                            (<p className="content-paragraph">{data.content} <span><i class="far fa-smile"></i></span></p>):
                            (<p className="content-paragraph">{data.content}</p>)
                        }
                        
                    </div>
                    <div className="col-md-3 col-lg-3"></div>
                </div>
            </div>
    </div>
);
}

export default HeroSectionContent;